import React from "react"
import { AppToolbarCreateButton } from "@components"

import { useAcrissGroups } from "Pages/User/Settings/AcrissGroupTab/@hooks"


export default function AcrissGroupsButton() {
	const { handleSetFormData } = useAcrissGroups()

	return <AppToolbarCreateButton
		label="Define Group"
		onClick={handleSetFormData}
	/>
}
